import React, { useContext } from 'react';
import { ActualIconProps } from 'mobx/commonTypes';
import { useTheme } from '@mui/material/styles';
import { UiContext } from 'uiContext';
import { defaultSpacingPresets } from 'hooks/useGetSpacing';

export default function IconSemiPowerRain({
  style,
  extColor,
  isAutoscallable = true,
  sizeKey = '32x32',
}: ActualIconProps) {
  const theme = useTheme();
  const fill = extColor || theme.palette.customBackgrounds.contrast;
  const {
    spacings: {
      icons: { [sizeKey]: size },
    },
  } = useContext(UiContext);

  const w = isAutoscallable ? size.w : defaultSpacingPresets.icons[sizeKey].w;
  const h = isAutoscallable ? size.h : defaultSpacingPresets.icons[sizeKey].h;

  return (
    <svg
      style={style}
      width={w}
      height={h}
      viewBox="0 0 32 32"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.84848 21.8998C8.62655 22.5113 8.93081 22.9092 9.42181 23.0882C9.91281 23.2672 10.4026 23.158 10.6263 22.5465C10.8483 21.935 10.513 20.0933 10.513 20.0933C10.513 20.0933 9.07101 21.2883 8.84908 21.8998H8.84848Z"
        fill="white"
      />
      <path
        d="M16.0325 25.8065C15.81 26.418 16.1148 26.8159 16.6058 26.9949C17.0968 27.1739 17.5866 27.0647 17.8104 26.4532C18.0323 25.8417 17.697 24 17.697 24C17.697 24 16.255 25.195 16.0331 25.8065H16.0325Z"
        fill="white"
      />
      <path
        d="M10.8484 25.8065C10.6265 26.418 10.9308 26.8159 11.4218 26.9949C11.9127 27.1739 12.4025 27.0647 12.6263 26.4532C12.8482 25.8417 12.5129 24 12.5129 24C12.5129 24 11.071 25.195 10.849 25.8065H10.8484Z"
        fill="white"
      />
      <path
        d="M14.0325 21.8998C13.81 22.5113 14.1148 22.9092 14.6058 23.0882C15.0968 23.2672 15.5866 23.158 15.8104 22.5465C16.0323 21.935 15.697 20.0933 15.697 20.0933C15.697 20.0933 14.255 21.2883 14.0331 21.8998H14.0325Z"
        fill="white"
      />
      <path
        d="M19.2171 21.8998C18.9945 22.5113 19.2994 22.9092 19.7904 23.0882C20.2814 23.2672 20.7712 23.158 20.9949 22.5465C21.2169 21.935 20.8816 20.0933 20.8816 20.0933C20.8816 20.0933 19.4396 21.2883 19.2177 21.8998H19.2171Z"
        fill="white"
      />
      <path
        d="M21.7595 8.84744C21.7124 8.84744 21.6671 8.85281 21.6205 8.8546C21.0973 6.64541 19.1178 5 16.7487 5C14.2597 5 12.1997 6.81604 11.8095 9.19466C11.4987 9.10815 11.1736 9.05864 10.8341 9.05864C9.11054 9.05864 7.67155 10.262 7.30345 11.8728C5.95574 12.4026 5 13.7109 5 15.2465C5 17.2481 6.62214 18.8708 8.62432 18.8708H21.7601C24.5289 18.8708 26.7727 16.627 26.7727 13.8594C26.7727 11.0918 24.5283 8.84684 21.7601 8.84684L21.7595 8.84744Z"
        fill="white"
      />
    </svg>
  );
}
